import { DateTime } from 'luxon';
import { ActivitySession, FlexibleSessionInstance } from './my-elements-my-activity-types';

// Normalise a date-ish value to a YYYY-MM-DD key so comparisons ignore any time component.
const toDateKey = (value?: string | null): string | undefined => {
  if (!value) {
    return undefined;
  }
  const parsed = DateTime.fromISO(value);
  return parsed.isValid ? parsed.toISODate() ?? undefined : value.slice(0, 10);
};

// currentFlexibleInstances can hold multiple upcoming dated instances (server returns every
// instance with sessionDate >= today), so we must find the one matching this activity date
// rather than assuming index 0.
export const findFlexibleInstanceForDate = (
  session: ActivitySession | undefined,
  activityDate?: string
): FlexibleSessionInstance | undefined => {
  const instances = session?.currentFlexibleInstances;
  if (!instances || instances.length === 0) {
    return undefined;
  }
  const targetKey = toDateKey(activityDate);
  return instances.find(
    (instance) =>
      instance && (!instance.sessionDate || (!!targetKey && toDateKey(instance.sessionDate) === targetKey))
  );
};

// The effective start/end time for a session on a given date: the matching flexible instance's
// time for flexible sessions, otherwise the session's own time.
export const getEffectiveSessionTimes = (
  session: ActivitySession | undefined,
  activityDate?: string
): { startTime?: string; endTime?: string } => {
  if (!session) {
    return {};
  }
  if (session.isFlexible) {
    const instance = findFlexibleInstanceForDate(session, activityDate);
    return { startTime: instance?.startTime, endTime: instance?.endTime };
  }
  return { startTime: session.startTime, endTime: session.endTime };
};
